import AvatarImageCircle from '../AvatarImageCircle';
import MapPin from 'Images/svg/map-pin.svg';
import Star from 'Images/svg/star-filled.svg';
import VerifiedCheck from 'Images/svg/verified-check-v2.turbopack-temp-svg';
import { Popover } from 'antd';

type ServiceProviderAvatarWithNameAndRatingProps = {
  serviceProviderAvatarImageUrl: string | null;
  displayName: string;
  averageRating: number;
  reviewCount: number;
  onClickReviewCount?: () => void;
  hideServesLocalAreaCopy?: boolean;
  isVerified: boolean;
}

const ServiceProviderAvatarWithNameAndRating: React.FC<ServiceProviderAvatarWithNameAndRatingProps> = ({
  serviceProviderAvatarImageUrl,
  displayName,
  averageRating,
  reviewCount,
  onClickReviewCount,
  hideServesLocalAreaCopy,
  isVerified,
}) => {
  return (
    <div className="flex gap-2">
      {serviceProviderAvatarImageUrl ? (
        <div>
          <AvatarImageCircle
            src={serviceProviderAvatarImageUrl}
            alt='Service Provider Avatar'
          />
        </div>
      ) : null/** maybe some default image? */}
      <div>
        <div className="flex gap-4">
          <h3
            className="font-bold text-2xl"
          >
            {displayName}
          </h3>
          {isVerified && (
            <Popover
              content={(
                <p>
                  This provider has been manually vetted and approved by the Peazy team.
                </p>
              )}
            >
              <VerifiedCheck className="mr-1 fill-primary scale-75" />
            </Popover>
          )}
        </div>
        {reviewCount > 0 && (
          <div
            className="flex items-center gap-2"
            onClick={() => onClickReviewCount && onClickReviewCount()}
          >
            <Star className="mt-[-5px] fill-[#f47451]" />
            <span>
              {averageRating.toFixed(1)}&nbsp;
            </span>
            <span className={onClickReviewCount ? 'underline' : ''}>
              {`(${reviewCount} reviews)`}
            </span>
          </div>
        )}
        {hideServesLocalAreaCopy || (
          <div className="flex items-center gap-2">
            <MapPin className="min-w-3" />
            <span>
              Winnipeg and surrounding areas
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceProviderAvatarWithNameAndRating;
